import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Fieldset, Checkboxes, Button } from 'govuk-react-jsx';
import {
  setPropertyTypesSelected,
  getPropertyTypesSelected,
  setAnswers,
} from '../../features/registration/registrationJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { checkAnswers, updateAccount } from '../../firebase';

const PropertyTypes = () => {
  const propertyTypesSelected = useSelector(getPropertyTypesSelected);
  const dispatch = useDispatch();
  const [hasError, setHasError] = useState(false);
  const history = useHistory();
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  const redirectCheckAnswers = () => {
    checkAnswers()
      .then((response) => {
        const { data } = response;

        dispatch(setAnswers(data));

        history.push('/landlordReg/check-your-answers');
      })
      .catch(() => {
        // TODO: Show error message
      });
  };

  const handleBtnClick = () => {
    if (!propertyTypesSelected.length) {
      setHasError(true);
    } else {
      let propertyType = null;

      const includesCommerical = propertyTypesSelected.includes('Commercial');
      const includesResidential = propertyTypesSelected.includes('Residential');

      if (includesCommerical && includesResidential) {
        propertyType = 'Both';
      } else if (includesCommerical) {
        propertyType = 'Commercial';
      } else if (includesResidential) {
        propertyType = 'Residential';
      }

      updateAccount({
        propertyType,
      })
        .then(() => {
          setHasError(false);

          redirectCheckAnswers();
        })
        .catch(() => {
          // TODO: Show error
        });
    }
  };

  const handleSelection = (event) => {
    const data = { value: event.target.value, checked: event.target.checked };
    dispatch(setPropertyTypesSelected(data));
  };

  const pageModel = (
    <>
      <Fieldset
        legend={{
          children: copyProvider.getCopy(
            'landlordReg.PropertyTypes.s1',
            'What type of properties do you own?'
          ),
          className: 'govuk-fieldset__legend govuk-fieldset__legend--xl',
          isPageHeading: true,
        }}
      >
        <p className="govuk-body govuk-!-margin-top-6">
          {copyProvider.getCopy(
            'landlordReg.PropertyTypes.s2',
            'OZEV grants are available for both residential and commercial properties. However, different rules and limits apply for each type. You will be able to create applications for both but will have to complete them separately.'
          )}
        </p>
        <p className="govuk-body govuk-!-margin-top-6">
          {copyProvider.getCopy(
            'landlordReg.PropertyTypes.s3',
            'Select the property types that you own and intend to use the grant for.'
          )}
        </p>

        {/* If user don't check at least one of the two boxes before clicking on the Continue btn, then error msg will be display on the UI. */}
        <Checkboxes
          onChange={(event) => handleSelection(event)}
          errorMessage={
            hasError && {
              children: copyProvider.getCopy(
                'landlordReg.PropertyTypes.s4',
                'Select a property type'
              ),
            }
          }
          idPrefix="example"
          items={[
            {
              children: copyProvider.getCopy(
                'landlordReg.PropertyTypes.s5',
                'Residential'
              ),
              value: 'Residential',
              checked: propertyTypesSelected.includes('Residential'),
            },
            {
              children: copyProvider.getCopy(
                'landlordReg.PropertyTypes.s6',
                'Commercial'
              ),
              value: 'Commercial',
              checked: propertyTypesSelected.includes('Commercial'),
            },
          ]}
        />
      </Fieldset>
      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy('landlordReg.PropertyTypes.s7', 'Continue')}
      </Button>
    </>
  );

  // returning the data or value from pageModel.
  return pageModel;
};

export default PropertyTypes;
